import { gql } from "graphql-tag"
import { fetchGQL } from "app/api"
import {
  SaveArticlePlantTypesMutation,
  SaveArticlePlantTypesMutationVariables,
} from "generated/graphql"

const SAVE_ARTICLE_PLANT_TYPES = gql`
  mutation saveArticlePlantTypes($in: SaveArticlePlantTypeInput!) {
    saveArticlePlantTypes(in: $in)
  }
`

export const saveArticlePlantTypes = async (
  bdb: number,
  plantTypeIds: number[]
): Promise<SaveArticlePlantTypesMutation | undefined> => {
  const variables: SaveArticlePlantTypesMutationVariables = {
    in: {
      bdb,
      plantTypeIds,
    },
  }
  const data = await fetchGQL<
    SaveArticlePlantTypesMutation,
    SaveArticlePlantTypesMutationVariables
  >(SAVE_ARTICLE_PLANT_TYPES, variables)
  return data
}
